import React from "react";
import { CSVLink, CSVDownload } from "react-csv";
import { Assessment2bFuelTypeInfo } from "../state";


interface Assessment2bDownloadCSVProps {
    fuelTypes: Assessment2bFuelTypeInfo[];
}

function Assessment2bDownloadCSV({ fuelTypes }: Assessment2bDownloadCSVProps) {

    
    const csvData = [["Fuel", "Action Plan"]];
        let rowIndex:number = 1;
        //iterate fuel types
        fuelTypes.map(fuel => {
            let actionPlan:string = "";
            if (fuel.hHServedByVendorsDataRequestedDesc !== null) {
                actionPlan += fuel.hHServedByVendorsDataRequestedDesc + " --- "
            } 
            if (fuel.hHServedByVendorsDataReceivedDesc !== null) {
                actionPlan += fuel.hHServedByVendorsDataReceivedDesc + " --- "
            } 
            if (fuel.hHWithElectricDataDesc !== null) {
                actionPlan += fuel.hHWithElectricDataDesc + " --- "
            } 
            if (fuel.improvePercenthouseholdDataColDesc !== null) {
                actionPlan += fuel.improvePercenthouseholdDataColDesc + " --- "
            }             
            csvData[rowIndex] = [fuel.description
                                  , actionPlan];
            rowIndex++; 
        });
    return (
      <CSVLink data={csvData} filename="ElectricBaseloadAssessment2b.csv" className="dataButton">Download as CSV</CSVLink>
    );
}


export default Assessment2bDownloadCSV;
